"use strict";
// Copyright (c) 2026 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALP_DEX_MAKER_FEE_SCRIPT_SET = exports.ALP_SWAP_PLATFORM_FEE_SCRIPT_SET = exports.ALP_DEX_MAKER_FEE_ADDRESSES = exports.ALP_SWAP_PLATFORM_FEE_ADDRESSES = void 0;
const ecashaddrjs_1 = require("ecashaddrjs");
/**
 * Legacy coordinator (alp-swap) platform fee payout addresses.
 * Historical settles may still include this out; standalone alp-dex does not.
 */
exports.ALP_SWAP_PLATFORM_FEE_ADDRESSES = [
    'ecash:qqfuy9k04vxglgqy8v5f6p89ks7h94msycf95lpern',
];
/**
 * Known alp-dex maker/LP fee payout addresses (HD account 2 / FEE_ADDRESS).
 * Unknown fee outs on a settle still classify as makerFee by structure.
 */
exports.ALP_DEX_MAKER_FEE_ADDRESSES = [
    'ecash:qqk7skx0u94avx4znwfj2ryv49plngf855v32pfn3c',
    // Legacy analytics fee addresses
    'ecash:qzw8yukk99r23mv5zc9ryshvek9tlqt0f52yhsuru8',
    'ecash:qqlrju5xpcrhxke2lt60q6nrjfnpsgqjw52ajykxth',
];
exports.ALP_SWAP_PLATFORM_FEE_SCRIPT_SET = new Set(exports.ALP_SWAP_PLATFORM_FEE_ADDRESSES.map(addr => (0, ecashaddrjs_1.getOutputScriptFromAddress)(addr)));
exports.ALP_DEX_MAKER_FEE_SCRIPT_SET = new Set(exports.ALP_DEX_MAKER_FEE_ADDRESSES.map(addr => (0, ecashaddrjs_1.getOutputScriptFromAddress)(addr)));
//# sourceMappingURL=alpSwapFees.js.map